// extracted by mini-css-extract-plugin
module.exports = {"seoMenu":"_93c7720","arrow":"_b480c80","closed":"_6d45819","navItem":"_d4a96b7","navItemActive":"_99d3bb7","active":"_5a2b1a7"};